import React, { FC } from 'react'
import styles from 'styles/components/typography.module.scss'
import { FlexRow } from 'components/Flex'
import { Spacer } from 'components/Utility'
import { RequiredLabel } from 'components/Label'

type Props = {
  headline: string
  iconPath?: string
  id?: string
  required?: boolean
}

const SubHeadline: FC<Props> = React.memo((props) => {
  const { headline, iconPath, id, required } = props
  return (
    <FlexRow justifyContent={'start'}>
      {iconPath && (
        <>
          <img src={iconPath} alt={headline} />
          <Spacer size={4} axis={'horizontal'} />
        </>
      )}
      <h3 className={styles.headline_sub} id={id}>
        {headline}
      </h3>
      {required && (
        <>
          <Spacer size={4} axis={'horizontal'} />
          <RequiredLabel />
        </>
      )}
    </FlexRow>
  )
})

export default SubHeadline
